import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLedger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1998 14.5H4.0998C3.75502 14.5 3.42436 14.363 3.18057 14.1192C2.93677 13.8754 2.7998 13.5448 2.7998 13.2M2.7998 13.2V3.23333C2.7998 2.77362 2.98242 2.33274 3.30749 2.00768C3.63255 1.68262 4.07343 1.5 4.53314 1.5H12.7665C12.8814 1.5 12.9916 1.54565 13.0729 1.62692C13.1541 1.70819 13.1998 1.81841 13.1998 1.93333V11.4667C13.1998 11.5816 13.1541 11.6918 13.0729 11.7731C12.9916 11.8543 12.8814 11.9 12.7665 11.9H4.0998C3.75502 11.9 3.42436 12.037 3.18057 12.2808C2.93677 12.5245 2.7998 12.8552 2.7998 13.2ZM12.3331 14.5V11.9",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLedger;
